import { PackQuantitiesWithMultiplier } from '../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { OrderProductSelectedPack } from '../../../../../../../products/details/productDetails.types';

export enum CommonGridTypeEnum {
  SUGGESTED_GRID = 'SUGGESTED_GRID',
  PACK_GRID = 'PACK_GRID',
}

export type QuantityByProductSizeId = Map<string, number>;

export interface GridQuantitiesBySize {
  sizeId: string;
  sizeName: string;
  sizeQuantity: number;
}

export interface IOrderProductCommonGrid {
  gridId: string;
  gridName: string;
  gridType: CommonGridTypeEnum;
  gridQuantities: GridQuantitiesBySize[];
}

export type HandleSelectSuggestion = (
  updateGrid: IOrderProductCommonGrid,
  suggestedPacks?: OrderProductSelectedPack[],
) => void;

export type HandleSelectPacks = (packs: PackQuantitiesWithMultiplier[]) => void;

export type SelectPacksSideEffect = (packs: PackQuantitiesWithMultiplier[]) => void;
